import performanceCollection from "@al/performance-collect";
import { getLCP, getFCP } from "web-vitals";
import BridgeV2 from "@akulaku/web-bridge";

import { isIos } from "../utils";

const observeData = {};

// 监听LCP时间回调函数
function webVitalsCallback(data) {
  observeData[data.name] = data.value;
  shouldReportData();
}

// 获取页面渲染模式
function getPageMode() {
  const SSR_MODE = "ssr"; //服务端渲染
  const EXPORT_MODE = "export"; // 导出模式
  const DOWNGRADE_MODE = "download"; // 降级
  const OFFLINE_MODE = "offline"; // 离线包

  let pageMode = performanceCollection.getPageMode();
  if (pageMode === OFFLINE_MODE) {
    return "offline";
  } else if (pageMode === SSR_MODE) {
    return "ssr";
  } else {
    return "csr";
  }
}

// 是否需要上报数据
function shouldReportData() {
  if ((observeData.LCP && observeData.FCP) || (observeData.FCP && isIos())) {
    const traceNamePrefix = isIos() ? "ios_" : "";
    performanceCollection.firebaseReadyCallback(() => {
      const transPortOptions = {
        traceName: getPageMode() + "_" + traceNamePrefix + observeData.traceName,
        startTime: new Date().getTime(),
        duration: observeData.LCP || observeData.FCP,
        options: {
          metrics: {
            lcp: observeData.LCP || observeData.FCP,
            fcp: observeData.FCP,
          },
          attributes: {
            // 记录是安卓、ios、站内、还是站外等信息
            platformInfo: `${BridgeV2.isAkulakuIOS() ? "ios" : "android"}_${
              BridgeV2.isAkulaku() ? "webview" : "browser"
            }`,
          },
        },
      };
      // 非正式环境添加打印数据
      if (process.env.BUILD_ENV !== "prod") {
        // eslint-disable-next-line
        console.log("custom report performance info:", transPortOptions);
      }
      transport(transPortOptions);
    });
  }
}

// 手动上报firebase数据
function transport({ traceName, startTime, duration, options }) {
  const pref = performanceCollection.firebase.performance();
  const trace = pref.trace(traceName);
  trace.record(startTime, duration, options);
}

function performanceReport({ traceName }) {
  if (window && traceName) {
    observeData.traceName = traceName;
    getLCP(webVitalsCallback);
    getFCP(webVitalsCallback);
  }
}

export default performanceReport;
